import { AutogenModelMarket, AutogenRowMarket } from "./autogen/AutogenModelMarket";

export class ModelMarket extends AutogenModelMarket<RowMarket> {
    constructor() {
        super(RowMarket);
    }
}

export class RowMarket extends AutogenRowMarket {
}